var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_12131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.857422 3.42861C0.857422 2.00844 2.00868 0.857178 3.42885 0.857178H8.57171C9.99187 0.857178 11.1431 2.00844 11.1431 3.42861V8.57146C11.1431 9.99163 9.99187 11.1429 8.57171 11.1429H3.42885C2.00868 11.1429 0.857422 9.99163 0.857422 8.57146V3.42861ZM12.8574 15.4286C12.8574 14.0084 14.0087 12.8572 15.4289 12.8572H20.5717C21.9918 12.8572 23.1431 14.0084 23.1431 15.4286V20.5715C23.1431 21.9916 21.9918 23.1429 20.5717 23.1429H15.4289C14.0087 23.1429 12.8574 21.9916 12.8574 20.5715V15.4286ZM12.8574 6.00003C12.8574 3.15972 15.16 0.857178 18.0003 0.857178C20.8407 0.857178 23.1431 3.15972 23.1431 6.00003C23.1431 8.84035 20.8407 11.1429 18.0003 11.1429C15.16 11.1429 12.8574 8.84035 12.8574 6.00003ZM6.00028 12.8572C3.15996 12.8572 0.857422 15.1597 0.857422 18C0.857422 20.8404 3.15996 23.1429 6.00028 23.1429C8.84059 23.1429 11.1431 20.8404 11.1431 18C11.1431 15.1597 8.84059 12.8572 6.00028 12.8572Z",
    fill: "#423E51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_12131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.b3bb80cff649d7963b9a9c9e36863c51.svg";
export { ForwardRef as ReactComponent };